import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import Layout from "@/components/Page/Layout";
import Contact from "@/components/Page/Contact";
import { TFunction } from "next-i18next";
import { serverSidePage } from "@/utils/serverSide";
import { Website } from "@/types/website";
import { GetServerSideProps } from "next";

type Props = {
  website: Website;
};

export const ContactPage = ({ website }: Props): React.ReactElement => (
  <Contact website={website} rounded={false} />
);

ContactPage.getLayout = function getLayout(
  page: React.ReactElement,
  t: TFunction
) {
  const { website } = page.props;

  return (
    <Layout title={t("website.contact")} website={website}>
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  query,
  req,
}) => ({
  props: {
    ...(await serverSidePage(query, req, false, "contact")),
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default ContactPage;
